<template>
    <div class="detail">
        <Header></Header>
        <div class="detail_main_box">
            <el-breadcrumb class="column_top_nav" separator-class="el-icon-arrow-right" style="font-size:14px;">
                <span style="float:left;">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>活动管理</el-breadcrumb-item>
                <el-breadcrumb-item>活动列表</el-breadcrumb-item>
                <el-breadcrumb-item><span class="active">活动详情</span></el-breadcrumb-item>
            </el-breadcrumb>
            <div class="detail_center_box">
                <h5 class="detail_center_title">长江经济带绿色发展研讨会在渝举行 深化对口支援合作 保护好长江母亲河</h5>
                <p class="detail_center_date">2022-02-05</p>
                <span class="detail_border"></span>
                <div class="detail_content_box">
                    实现湾区发展目标需要良好的营商税收环境。根据粤港澳大湾区自身特点，做好税收协调是营造湾区良好营商税收环境的关键。本文论述了营造粤港澳大湾区良好营商税收环境的必要性，并提出加强法制建设、建立税收协调制度，健全税收协调机构、定期组织联席会议，解决税制实施和税收征管矛盾、消除市场壁垒，建立粤港系统的建议，以促进湾区健康发展。
                </div>
                <div class="detail_bottom_list">
                    <h5>相关文章</h5>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                </div>
                <div class="detail_bottom_list">
                    <h5>作者的其他文章</h5>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                    <a href="javascript:void(0);">
                        <span>.  从“学术自治”到“混合治理”：论波兰高等教育治理模式的转变——基于政策趋同与历史制度主义的视角等教育治理模式的转变——基于政策等教育治理模式的转变——基于政策</span>
                        <i>2022-05-01</i>
                    </a>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import $ from "jquery";

import Header from "@/components/header";
import Footer from "@/components/footer";


export default {
    props: {},
    components: {
        Header,
        Footer
    },
    data() {
        return {
            
        };
    },
    computed: {},
    methods: {
        
    },
    created(){
        
    },
    mounted() {
        
    }
};
</script>
<style scoped lang="less">
.detail {
    width: 100%;
    height: 100%;
    background:#F2F2F2;
}
.detail_main_box{
    width:1200px;
    margin:0 auto;
    min-height: 600px;
}
.column_top_nav {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1A1A1A;
    line-height: 26px;
    height: 54px;
    line-height: 54px;
}
.detail_center_box{
    width:93%;
    min-height: 500px;
    padding:40px;
    overflow: hidden;
    margin-bottom: 50px;
    background:#fff;
    border: 1px solid #E9E9E9;
    box-shadow: 0px 0px 6px 0px #EEEEEE;
    margin:0 auto;
}
.detail_border{
    width: 100%;
    height: 1px;
    background: #EBEBEB;
    display: block;
    margin-top:63px;
}
.detail_center_title{
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    width:858px;
    margin:0 auto;
    text-align: center;
    line-height: 46px;
    margin-top: 30px;
}
.detail_center_date{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-top:30px;
}
.detail_content_box{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5B615A;
    line-height: 36px;
    margin-top:36px;
    min-height: 300px;
    border-bottom:1px solid #EBEBEB;
    padding-bottom:60px;
}
.detail_bottom_list{
    width:100%;
    overflow: hidden;
}
.detail_bottom_list h5{
    width:100%;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-top:35px;
    margin-bottom: 30px;
}
.detail_bottom_list a{
    width:100%;
    display: block;
    overflow: hidden;
    margin-bottom: 22px;
}
.detail_bottom_list a span{
    width:940px;
    line-height: 1;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5B615A;
    display: inline-block;
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}
.detail_bottom_list a span:hover{
    color:#4EAC41;
}
.detail_bottom_list a i{
    display: inline-block;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    font-style: normal;
    float:right;
}
.detail_bottom_list a i:hover{
    color:#4EAC41;
}



</style>


// WEBPACK FOOTER //
// src/view/detail/index.vue